import { request } from '@utils';

const postSearch = async (query) => {
  if (query.trim().length === 0) {
    return [];
  }

  const results = await request.post(`/v2/search?query=${query}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export { postSearch };
